import { z } from "zod/v4";

// These Protection Profiles require an SBOM be submitted prior to creating a VID
// WARN: NIAP wants to expand the required list.
// This is not a sustainable or expandable way to do things.
// We should evaluate once we have better requirements.
export const protectionProfilesRequiringSbom = [
  // Short names
  "PP_APP_v1.4",
  "CPP_APP_SW_V1.0e",
  "PP_APP_v2.0",
  // Long names
  "Protection Profile for Application Software Version 1.4",
  "collaborative Protection Profile for Application Software Version 1.0e",
  "Protection Profile for Application Software Version 2.0",
];

export const ProtectionProfilesSchema = z
  .object({
    sbom_submitted: z.boolean(),
    protection_profile: z
      .array(
        z.object({
          label: z.string(),
          value: z.number(),
        }),
      )
      .min(1, "At least one Protection Profile is Required"),
  })
  .refine(
    (data) => {
      const ppNeedsSbom = data.protection_profile?.some((pp) =>
        protectionProfilesRequiringSbom.includes(pp.label),
      );
      // If an sbom is required make sure it has been submitted
      return !ppNeedsSbom || data.sbom_submitted;
    },
    {
      message: "Required for Protection Profiles that require SBOM",
      path: ["sbom_submitted"],
    },
  );

export const ProtectionFilesDraftSchema = z.object({
  sbom_submitted: z.boolean(),
  protection_profile: z.array(
    z.object({
      label: z.string(),
      value: z.number(),
    }),
  ),
});
